import styled from 'styled-components';
import colors from 'themes/Main';

const { gray01 } = colors;

export const Container = styled.div`
  width: 100%;
  padding: 16px 32px;
  display: flex;
  flex-wrap: nowrap;
  min-height: 84px;
  align-items: center;
  background-color: #f8f9fa;

  > div {
    &:first-of-type {
      width: 190px;
      margin-right: 24px;
      justify-content: flex-start;
      align-items: center;
    }
  }
`;

export const BlockName = styled.div`
  min-width: 210px;
  margin-bottom: 0;
  color: ${gray01};
  font-weight: 700;
  font-size: 14px;
`;

export const AnyContent = styled.div``;
